<template>
	<image-filter :filter="'music'" />
</template>
<script>
import ImageFilter from '@/components/ImageFilter'

export default {
	name: 'home',
	components: {
		ImageFilter
	}
}
</script>
